import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
    FaUser, FaEnvelope, FaLock, 
    FaCheckCircle, FaEye, FaEyeSlash, FaIdBadge, 
    FaPhone
} from 'react-icons/fa'; // FaPhone dihapus karena tidak dipakai
import api from '../api/axios';
import { toast } from 'react-toastify';

const RegisterPage = () => {
    const navigate = useNavigate();
    
    // State tanpa teamName dan TANPA phone
    const [formData, setFormData] = useState({
        name: '', 
        username: '',
        email: '', 
        password: '', 
        confirmPassword: '',
        phone: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (formData.password !== formData.confirmPassword) {
            return toast.warning("Konfirmasi password tidak cocok!");
        }

        setIsLoading(true);

        try {
            const response = await api.post('/auth/register', formData);
            toast.success(response.data.msg || "Registrasi Berhasil! Silakan Login.");
            setTimeout(() => navigate('/login'), 2000);
        } catch (error) {
            const msg = error.response?.data?.msg || "Gagal Mendaftar.";
            toast.error(msg);
        } finally {
            setIsLoading(false);
        }
    };

    // Helper Render Input
    const renderInput = (label, icon, type, name, placeholder, isPassword = false, toggleState = false, setToggle = null) => (
        <div className="mb-3">
            <label className="form-label small fw-bold text-secondary ms-1">{label}</label>
            <div className="input-group">
                <span className="input-group-text border-end-0" style={styles.inputIcon}>
                    {icon}
                </span>
                <input 
                    type={isPassword ? (toggleState ? "text" : "password") : type} 
                    name={name}
                    className={`form-control ${isPassword ? 'border-start-0 border-end-0' : 'border-start-0'}`}
                    style={styles.inputField}
                    placeholder={placeholder}
                    required 
                    value={formData[name]}
                    onChange={handleChange}
                />
                {isPassword && (
                    <button 
                        type="button"
                        className="input-group-text border-start-0 bg-transparent"
                        style={{ cursor: 'pointer', borderTopRightRadius: '1rem', borderBottomRightRadius: '1rem' }}
                        onClick={() => setToggle(!toggleState)}
                    >
                        {toggleState ? <FaEyeSlash className="text-muted"/> : <FaEye className="text-muted"/>}
                    </button>
                )}
            </div>
        </div>
    );

    return (
        <div style={styles.pageContainer}>
            <div style={styles.blobTop}></div>
            <div style={styles.blobBottom}></div>

            <div className="container position-relative z-1 my-5">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-7">
                        <div className="card border-0 shadow-lg animate-slide-up" style={styles.glassCard}>
                            <div className="card-body p-4 p-md-5">
                                
                                <div className="text-center mb-4">
                                    <h3 className="fw-bold mb-1" style={styles.textGradient}>Registrasi Akun</h3>
                                    <p className="text-muted small">Buat akun manager untuk mengelola tim Anda.</p>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    {/* Baris 1: Nama & Username */}
                                    <div className="row">
                                        <div className="col-md-6">
                                            {renderInput("Nama Lengkap", <FaUser className="text-primary"/>, "text", "name", "Nama Manager")}
                                        </div>
                                        <div className="col-md-6">
                                            {renderInput("Username", <FaIdBadge className="text-primary"/>, "text", "username", "Username Unik")}
                                        </div>
                                    </div>

                                    {/* Baris 2: Email (Dibuat Full Width karena No HP dihapus) */}
                                    <div className="row">
                                        <div className="col-12">
                                            {renderInput("Email Address", <FaEnvelope className="text-primary"/>, "email", "email", "manager@email.com")}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            {renderInput("Nomor Telepon", <FaPhone className="text-primary"/>, "tel", "phone", "081234567890")}
                                        </div>
                                    </div>

                                    {/* Baris 3: Password & Confirm */}
                                    <div className="row">
                                        <div className="col-md-6">
                                            {renderInput("Password", <FaLock className="text-primary"/>, "password", "password", "••••••", true, showPassword, setShowPassword)}
                                        </div>
                                        <div className="col-md-6">
                                            {renderInput("Konfirmasi Password", <FaCheckCircle className="text-primary"/>, "password", "confirmPassword", "••••••", true, showConfirmPassword, setShowConfirmPassword)}
                                        </div>
                                    </div>

                                    <button 
                                        type="submit" 
                                        className="btn w-100 py-2 shadow-sm mb-3 text-white fw-bold hover-scale"
                                        style={styles.submitBtn}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Memproses...' : 'Buat Akun'}
                                    </button>
                                </form>

                                <div className="text-center mt-3">
                                    <p className="small text-muted mb-0">
                                        Sudah punya akun? 
                                        <Link to="/login" className="fw-bold text-decoration-none ms-1" style={{ color: 'var(--secondary-color)' }}>
                                            Login Disini
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    pageContainer: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        position: 'relative',
        overflow: 'hidden',
        padding: '2rem 0'
    },
    glassCard: {
        background: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(15px)',
        borderRadius: '1.5rem',
        border: '1px solid rgba(255, 255, 255, 0.6)',
    },
    textGradient: {
        background: 'var(--primary-gradient)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    inputIcon: {
        background: 'white',
        borderTopLeftRadius: '0.8rem',
        borderBottomLeftRadius: '0.8rem',
        borderColor: '#e2e8f0',
        paddingLeft: '1rem'
    },
    inputField: {
        background: 'white',
        borderColor: '#e2e8f0',
        paddingTop: '0.7rem',
        paddingBottom: '0.7rem',
        borderTopRightRadius: '0.8rem', 
        borderBottomRightRadius: '0.8rem'
    },
    submitBtn: {
        background: 'var(--primary-gradient)',
        border: 'none',
        borderRadius: '50px',
    },
    blobTop: {
        position: 'absolute',
        top: '-10%',
        right: '-5%',
        width: '600px',
        height: '600px',
        background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, rgba(0,0,0,0) 70%)',
        borderRadius: '50%',
        zIndex: 0,
        filter: 'blur(70px)'
    },
    blobBottom: {
        position: 'absolute',
        bottom: '-10%',
        left: '-10%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(244,63,94,0.1) 0%, rgba(0,0,0,0) 70%)',
        borderRadius: '50%',
        zIndex: 0,
        filter: 'blur(70px)'
    }
};

export default RegisterPage;